import React, { useContext } from "react";
import leftArrow from "../../images/leftArrow.png";
import rightArrow from "../../images/rightArrow.png";
import MainContext from "../../state/main/mainContext";

const Buttons = ({ advance, goBack }) => {
  const mainContext = useContext(MainContext);
  const { prevStep } = mainContext;
  return (
    <div className="button-group">
      <div onClick={goBack} className="btn btn-red">
        <img src={leftArrow} alt="" />
      </div>
      <div onClick={advance} className="btn btn-green">
        <img src={rightArrow} alt="" />
      </div>
    </div>
  );
};

export default Buttons;
